<template>
	<div>
		<h1>{{ title }}</h1>
		<LockInfo class="mb-3"/>
		<div class="tag-sections">
			<section class="tag">
				<CharacteristicSelectInline
					v-model="functions"
					:characteristic-items="functionCharacteristicItems"
					:characteristic-type="meta.functionType"
					:initial-amount="!functionsValid ? 10 : 1000"
					show-multiple-hint
					:supplements-config="{
						nothingAllowed: false,
						types: supplementTypes
					}"
					:fan-config="{
						showMultipleHint: true,
						withKeyword: true,
						titleFormats: {
							default: 'Welche Tätigkeiten und Aufgaben im Bereich <br />%characteristicLabel%?',
							level: {
								1: 'Welche Tätigkeiten und Aufgaben im Bereich <br />%title%?'
							}
						},
						searchConfig: {
							catalog: meta.searchCatalogFunction
						}
					}"
					:search-catalog="meta.searchCatalogFunction"
					with-keyword
					keyword-placeholder="Tätigkeit, Aufgabenbereich eingeben (mind. 3 Zeichen)"
					:group-by-letter="{
						enabled: true
					}"
					:label-type="labelTypeJobProfile"
					@input="emitChangeEvent"
				/>
			</section>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import CharacteristicSelectInline from "@/vue/characteristic/SelectInline"
import {isDefined} from "@/helper/Value";
import {getQueryParams} from "@/helper/Url";
import {JOB_PROFILE} from "@/helper/characteristic/Label";
import {RELEVANT_SUPPLEMENT_TYPES} from "@/helper/characteristic/Functions";
import LockInfo from "@/vue/common/LockInfo.vue";

export default {

	components: {
		LockInfo,
		CharacteristicSelectInline,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
		title: {
			type: String,
			required: true,
		},
	},

	data ()
	{
		const queryParams = getQueryParams();

		return {
			channel: queryParams.channel,
			functions: this.value?.functions,
		};
	},

	computed: {
		...mapState('meta', [
			'meta',
		]),
		supplementTypes ()
		{
			return RELEVANT_SUPPLEMENT_TYPES;
		},
		functionCharacteristicItems ()
		{
			return this.meta.function;
		},
		labelTypeJobProfile ()
		{
			return JOB_PROFILE;
		},
		functionsValid ()
		{
			return isDefined(this.functions);
		},
		valid ()
		{
			return this.functionsValid;
		}
	},

	methods: {
		...mapActions('characteristic/fan', {
			showFan: 'show'
		}),
		emitChangeEvent ()
		{
			this.$emit('input', {
				functions: this.functions,
				valid: this.valid
			});
		},
	},
}
</script>
